import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@features/auth/auth.service'
import { APP_ROUTE_NAMES } from '@app/app.routes'

export const authenticatedGuard = () => {
  if (inject(AuthService).authenticated) {
    return true
  }

  return inject(Router).createUrlTree(['/', APP_ROUTE_NAMES.LOGIN])
}
